import { database } from './firebase'

/**
 * A medical note still waiting for its first payment - the same rule as the
 * backend's shouldSkipMedicalNote (cloudfunctions listeners.js): it has a payment
 * link, is not paid, was not refunded, and was not declined (a declined note,
 * including one expired after 30 days unpaid, is decided, not pending payment).
 */
export const isAwaitingMedicalNotePayment = (note) =>
  Boolean(note && note.paymentLink && note.used === false && !note.refunded && note.status !== 'declined');

// helper: check if medical note should be skipped
export const shouldSkipMedicalNote = async (conversationID) => {
  if (!conversationID) return false;

  try {
    const snap = await database.ref(`/medicalNotes/${conversationID}`).once('value');
    const data = snap.val();

    if (!data) return false;

    // Skipped while it waits for its first payment (same rule as the backend).
    return isAwaitingMedicalNotePayment(data);
  } catch (error) {
    console.error("Error reading medicalNotes for skip logic:", error);
    return false;
  }
};

 
 export const checkAllStatuses = async (delegateData, delegateConvoObj, conversationID) => {
    const statusMapping = {
      labRequisitionData: "labStatus",
      imagingData: "imagingStatus",
      medicalNotesData: "medicalNoteStatus",
      prescriptionData: "prescriptionStatus",
    };
    //   const presentDataKeys = Object.keys(statusMapping).filter(
    //   (key) => delegateData[key]
    // );

    const presentConvoKeys = Object.keys(statusMapping).filter((dataKey) =>
    delegateConvoObj[dataKey] !== null && delegateConvoObj[dataKey] !== undefined
  );

  const presentDelegateKeys = Object.keys(statusMapping).filter((dataKey) =>
    delegateData[dataKey] !== null && delegateData[dataKey] !== undefined
  );

  // Merge and remove duplicates
  const presentDataKeys = Array.from(new Set([...presentConvoKeys, ...presentDelegateKeys]));


    console.log("Present data keys: in funcccc", presentDataKeys);
    console.log("Delegate convo object: in func", delegateConvoObj);


    if (presentDataKeys.length === 0) {
      console.log("No data to track, navigating to pending");
      return false;
    }

      const skipMedicalNote = await shouldSkipMedicalNote(conversationID);

      const statuses = presentDataKeys.map((key) => ({
      key,
      status: delegateConvoObj[statusMapping[key]],
    }));
  
    console.log("Statuses found:", statuses);
  
    // const allProcessed = statuses.every(
    //   (item) => item.status === "approved" || item.status === "declined"
    // );

  console.log("Statuses found:", statuses);
  console.log("Skip medical note?", skipMedicalNote);

  const allProcessed = statuses.every((item) => {
    // Skip medical note approval/decline check
    if (item.key === "medicalNotesData" && skipMedicalNote) {
      return true; // treat as passed
    }

    // Normal rule
    return item.status === "approved" || item.status === "declined";
  });
  
    console.log("All processed:", allProcessed);
  
    return allProcessed;
  };
